import { CODE_TYPE, DEVICE_TYPE, PAYMENT_TYPES, RESTRICTION_TYPE } from "../../../Common/constants";
import React from "react";
import { FormattedMessage } from "react-intl";
import globalMessages from "../../../intl/globalMessages";
import GeneralTranslations from "../../../Common/ModuleTranslations/es";
import { formatEpochTimeSeconds, isEpochTimeBeforeNow } from "./utils";

export default {
  locale: "es",
  name: "Formas de cobro",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "type",
        displayName: "Tipo de pago",
      },
      {
        fieldName: "title",
        displayName: "Título",
      },
      {
        fieldName: "minRelease",
        displayName: "Antelación mínima (hrs)",
      },
      {
        fieldName: "maxRelease",
        displayName: "Antelación máxima (hrs)",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "type",
      },
      {
        fieldName: "merchantId",
        displayName: "Merchant Id",
      },
      {
        fieldName: "merchantPassword",
        displayName: "Merchant Password",
      },
      {
        fieldName: "merchantAccount",
        displayName: "Merchant Account",
      },
      {
        fieldName: "publicApiKey",
        displayName: "Client Key",
      },
      {
        fieldName: "prefix",
        displayName: "Production Prefix",
      },
      {
        fieldName: "installmentsIsActive",
        displayName: "Parcelado activo?",
      },
      {
        fieldName: "installmentsValues",
        displayName: "Número de cuotas",
      },
      {
        fieldName: "secret",
        displayName: ({ formValues }) =>
          formValues.type === PAYMENT_TYPES.CRIPTAN ? "Secret" : "Clave",
      },
      {
        fieldName: "rebatePassword",
        displayName: "Rebate password",
      },
      {
        fieldName: "pnpClient",
        displayName: "Cliente",
      },
      {
        fieldName: "pnpGateway",
        displayName: "Carta de pago",
      },
      {
        fieldName: "key",
        displayName: "Clave",
      },
      {
        fieldName: "clave256",
        displayName: "Clave encriptación",
      },
      {
        fieldName: "Ds_Merchant_MerchantCode",
        displayName: "MerchantCode",
      },
      {
        fieldName: "Ds_Merchant_Terminal",
        displayName: "MerchantTerminal",
      },
      {
        fieldName: "Ds_Merchant_Currency",
        displayName: "MerchantCurrency",
      },
      {
        fieldName: "Ds_Merchant_MerchantURL",
      },
      {
        fieldName: "url",
        displayName: "Url",
        helpText:
          'Url test "https://sis-t.redsys.es:25443/sis/realizarPago" / producción https://sis.redsys.es/sis/realizarPago',
      },
      {
        fieldName: "clientId",
        displayName: "Client",
      },
      {
        fieldName: "description",
        displayName: "Descripción",
      },
      {
        fieldName: "descriptionWithDeposit",
        displayName: "Descripción para depósito",
      },
      {
        fieldName: "descriptionWithoutDeposit",
        displayName: "Descripción sin depósito",
      },
      {
        fieldName: "roomLockHours",
        displayName: "Bloqueo de disponibilidad",
        helpText: "# de horas que guardamos la reserva para el cliente",
      },
      {
        fieldName: "automaticCancellation",
        displayName: "Cancelar automáticamente reservas caducadas",
      },
      {
        fieldName: "minDuration",
        displayName: "Antelación mínima (hrs)",
        helpText: "Si la antelación es menor no permite seleccionar este tipo de pago",
      },
      {
        fieldName: "maxDuration",
        displayName: "Antelación máxima (hrs)",
        helpText: "Si la antelación es mayor no permite seleccionar este tipo de pago",
      },
      {
        fieldName: "codesSection",
        displayName: "Código",
        helpText:
          "Sólo cuando se introduzca este código en el motor se activará este método de pago.",
      },
      {
        fieldName: "codeType",
        displayName: "",
        optionDisplay: {
          [CODE_TYPE.NO_CODE]: {
            label: "Sin código",
          },
          [CODE_TYPE.UNIVERSAL_CODE]: {
            label: "Código universal",
          },
        },
      },
      {
        fieldName: RESTRICTION_TYPE.CODE,
        displayName: "",
      },
      {
        fieldName: RESTRICTION_TYPE.DEVICE_TYPE,
        displayName: "Tipo de dispositivo",
        widget: "multicheckbox",
        defaultValue: [],
        selectables: true,
        options: [
          {
            ticker: DEVICE_TYPE.DESKTOP,
            name: "Desktop",
          },
          {
            ticker: DEVICE_TYPE.TABLET,
            name: "Tablet",
          },
          {
            ticker: DEVICE_TYPE.MOBILE,
            name: "Móvil",
          },
        ],
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "paymentMethods",
        displayName: "Métodos de pago",
        helpText: "Si el campo está vacío, se aplicarán todos los métodos de pagos disponibles",
      },
      {
        fieldName: "accountType",
        displayName: "Cuenta",
        helpText: "Sólo se puede vincular una cuenta nueva o una cuenta vinculada a Septeo/Tesipro",
        helpTextClassName: "text-red-500",
        options: [
          {
            value: "-",
            label: "-",
          },
          {
            value: "NEW",
            label: "Crear nueva cuenta",
          },
          {
            value: "EXISTING",
            label: "Vincular cuenta Septeo/Tesipro",
          },
        ],
      },
      {
        fieldName: "stripeAccountButton",
        displayBtn: "Crear cuenta enlazada",
      },
      {
        fieldName: "accountLink",
        displayName: "Enlace de incorporación a la cuenta",
        transform: ({ field, formValues }) => {
          const isExpired = isEpochTimeBeforeNow(formValues.accountLinkExpiresAt);
          const { date, time } = formatEpochTimeSeconds(formValues.accountLinkExpiresAt);

          return {
            ...field,
            helpText: isExpired
              ? "El enlace ha caducado, debe regenerar un nuevo enlace."
              : `El enlace caduca a las: ${time} h del ${date}`,
            helpTextClassName: "text-red-500",
          };
        },
      },
      {
        fieldName: "stripeAccountLinkButton",
        displayBtn: "Regenerar enlace",
      },
      {
        fieldName: "componentType",
        displayName: "Componente",
      },
      {
        fieldName: "username",
        displayName: "Usuario",
      },
      {
        fieldName: "password",
        displayName: "Contraseña",
      },
    ],
  },
};
